/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);
/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
      var value = '',
          placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = (format || this.money_format);
      if (typeof cents == 'string') {
          cents = cents.replace('.','');
      }
      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
            return 0;
          }
          number = (number/100.0).toFixed(precision);
          var parts   = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents   = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }
      switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
      }
      return formatString.replace(placeholderRegex, value);
    };
}
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function(selectorIndex) {
    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = jQuery('.single-option-selector:eq(0)');
            break;
        case 1:
            var key = jQuery('.single-option-selector:eq(0)').val();
            var selector = jQuery('.single-option-selector:eq(1)');
            break;
        case 2:
            var key = jQuery('.single-option-selector:eq(0)').val();  
            key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
            var selector = jQuery('.single-option-selector:eq(2)');
    }
    var initialValue = selector.val();
    selector.empty();    
    var availableOptions = Shopify.optionsMap[key];
    for (var i=0; i<availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = jQuery('<option></option>').val(option).html(option);
        selector.append(newOption);
    }
    jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
        }
        else {
            $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
        }
    });
    if (jQuery.inArray(initialValue, availableOptions) !== -1) {
        selector.val(initialValue);
    }
    selector.trigger('change');  
};
Shopify.linkOptionSelectors = function(product) {
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    jQuery(".single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
    // When there is an update in the second dropdown.
    jQuery(".single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
};
window.vela = window.vela || {};
vela.cacheSelectors = function () {
    vela.cache = {
        $html                       : $('html'),
        $body                       : $('body'),
        $recoverPasswordLink        : $('#RecoverPassword'),
        $hideRecoverPasswordLink    : $('#HideRecoverPasswordLink'),
        $recoverPasswordForm        : $('#RecoverPasswordForm'),
        $customerLoginForm          : $('#CustomerLoginForm'),
        $passwordResetSuccess       : $('#ResetSuccess'),
        $velaSlideShow              : $('#velaSlider'),
        $velaProductImage           : $('#js-product-image'),
        $velaLoading                : $('#loading')
    };
};

vela.topbar = function () {
    var runSlick = false;
    var topbarList = function() {
        var listItem = '.topbar__list';
        var autoplaySpeed = $(listItem).data('autoplay');
        if ($(window).width() <= 767) {
            if (!runSlick) {
                $(listItem).slick({
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: autoplaySpeed
                });
                runSlick = true;
            }
        } else {
          	if (runSlick) {
                $(listItem).slick('unslick');
                runSlick = false;
            }
        }
    };
    topbarList();
    $(window).on('resize', $.debounce(150, function() {
        topbarList();
    }));
};

vela.init = function () {
    FastClick.attach(document.body);
    vela.cacheSelectors();
    vela.startTheme();
    vela.drawersInit();
    //vela.responsiveVideos();
    vela.loginForms();
    vela.owlOneCarousel();
    vela.productThumbImage();
    vela.accordion();
    vela.wishlist();
    vela.quickview();
    vela.ajaxFilter();
    vela.productCountdown();
    vela.floatHeader();
    vela.gotop();
    vela.swatchProduct();
    vela.newsletter();
    vela.filterByPrice();
    $(vela.menumobile);
  	$(vela.filtersmobile);
  	vela.topbar();
    if (window.ajaxcart_type == "modal") {
        ajaxCart.load();
    }
};
vela.newsletter = function() {
    var $formNewsletter = $('.jsEnergeaNewsletter'),
        $formPopupNewsletter = $('.jsEnergeaPopupNewsletter'),
      $formAlert = $('.energeaPopupAlert'),
        $formAlertContent = $('.energeaPopupAlertDesc'),
        $popupNewsletter = $('.mailchimpPopupNewsletter');
    var alertSuccessHeading = "<div class='energeaPopupAlertHeading'>" +
          "Thank you for <br>joining our community</div>";
    var alertSuccess = "<p>Look out for us in your inbox as we keep <br>you in the loop of latest technology trends <br>and exclusive deals.</p>";
    $('body').on('submit', '.jsEnergeaNewsletter', function(e) {
        if (window.newsletter_recaptcha_enable) {
          if (!$('.js-recaptcha-footer').hasClass('show')) {
            $('.js-recaptcha-footer').show().addClass('show');
            return false;
          }
          var captchaResponse = grecaptcha.getResponse(footerNewsletter);
          if (captchaResponse.length == 0) {
            $formAlertContent.html('<div>' + window.newsletter_recaptcha_error + '</div>');
            $formAlert.addClass('active');
            return false;
          }
        }
        $.ajax({
          type: $formNewsletter.attr('method'),
            url: $formNewsletter.attr('action'),
            data: $formNewsletter.serialize(),
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            error: function (err) {
                $formAlertContent.html('<p>Could not connect to the registration server. Please try again later.</p>');
                $formAlert.addClass('active');
            },
            success: function (data) {
                if (data.result === 'success') {
                    $formAlertContent.html(alertSuccessHeading + alertSuccess);
                  $formAlert.addClass('active');
                    $formNewsletter.find('input[name="EMAIL"]').val('');
                } else {
                    console.log('Error newsletter: ', data.msg);
                    $formAlertContent.html('<div>' + data.msg + '</div>');
                  $formAlert.addClass('active');
                }
            }
        });
        e.preventDefault();
    });
    $('body').on('submit', '.jsEnergeaPopupNewsletter', function(e) {
        if (window.newsletter_recaptcha_enable) {
          if (!$('.js-recaptcha-popup').hasClass('show')) {
          	$('.js-recaptcha-popup').show().addClass('show');
            return false;
          }
          var captchaResponse = grecaptcha.getResponse(popupNewsletter);
          if (captchaResponse.length == 0) {
            $formPopupNewsletter.find('.formNewsletterError').html('<p>' + window.newsletter_recaptcha_error + '</p>');
            return false;
          }
        }
        $.ajax({
          type: $formPopupNewsletter.attr('method'),
            url: $formPopupNewsletter.attr('action'),
            data: $formPopupNewsletter.serialize(),
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            error: function (err) {
                $formPopupNewsletter.find('.formNewsletterError')
                  .html('<p>Could not connect to the registration server. Please try again later.</p>');
            },
            success: function (data) {
                if (data.result === 'success') {
                    $formPopupNewsletter.find('.formNewsletterError').empty();
                    $popupNewsletter.find('.velaTitle')
                      .html("Thank you for joining our community");
                    $formPopupNewsletter.addClass('hidden');
                    $popupNewsletter.find('.newsletterDescription').addClass('hidden');
                    $popupNewsletter.find('.mailchimpPopupNewsletterAlert').removeClass('hidden');
                    $formPopupNewsletter.find('input[name="EMAIL"]').val('');
                } else {
                    console.log('Error newsletter: ', data.msg);
                  $formPopupNewsletter.find('.formNewsletterError')
                    .html('<p>' + data.msg + '</p>');
                }
            }
        });
        e.preventDefault();
    });
    $('body').on('click', '.energeaPopupAlertOverlay, .energeaPopupAlertClose', function(e) {
        $('.energeaPopupAlert').removeClass('active');
      e.preventDefault();
    });
    $('body').on('click', '.btnClosePopupNewsletter', function(e) {
        $('.fancybox-overlay').trigger('click');
      e.preventDefault();
    });
};
vela.swatchProduct = function() {
    $('body').on('mouseover', '.velaSwatchProduct > li', function() {
        var newImage = $(this).find('.hidden a').attr('href');
        if (newImage != '#'){
            var eImage = $(this).parents('.velaProBlock').find('.proFeaturedImage > img');
            eImage.attr({
                src: newImage
            }).css({
                'position': 'relative',
                'z-index': '2'
            });
        }
        return false;
    });
    $('body').on('mouseout', '.velaProBlock', function() {
        var eImage = $(this).find('.proFeaturedImage > img');
        eImage.removeAttr('style');
    });
};
vela.drawersInit = function () {
    vela.LeftDrawer = new vela.Drawers('menuDrawer', 'Left', false);
    vela.RightDrawer = new vela.Drawers('cartDrawer', 'Right', true, {
      
    });
};
vela.getHash = function () {
    return window.location.hash;
};
vela.startTheme = function () {
    $(".swatch :radio").change(function() {
        var t = $(this).closest(".swatch").attr("data-option-index");
        var n = $(this).val();
        $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    $('.headerCartModal .overlayCart, .headerCartModal .closeCartModal').on('click', function(){
        $('.headerCartModal').removeClass('active');
    });
    $('body').on('click', '.js-vela-cart-top-icon', function() {
        $(this).parent().toggleClass('active');
    });
    $('body').click(function (e) {
        $('.js-collection-sort-by').removeClass('active');
        if ($(window).width() <= 1024) {
        	$('.js-vela-search-top').removeClass('active');
        }
    });
    $('.googleOverPlay').on('click', function(){
        $(this).fadeOut();
    });
    $('.velaGoogleMap').on('mouseleave', function() {
        $(this).find('.googleOverPlay').fadeIn();
    });
    $('body').on('click', '.alertOverlay', function() {
        $('.formContactAlert').remove();
    });
    $('body').on('click', '.alertClose', function() {
        $('.formContactAlert').remove();
    });
    $('body').on('click', '.closeNewsletterAlert, .newsletterAlertClose', function() {
        $('#newsletterAlert').removeClass('showNewsletterAlert');
    });
    $('body').on('click', '.js-close-topbar', function() {
        $('.js-topbar').remove();
      	$('.js-nheader').addClass('hidden-topbar');
    });
    if ($(window).width() > 1024) {
        $('.js-vela-search-top')
            .mouseover(function() {
                $(this).addClass('active');
            })
            .mouseout(function() {
                $(this).removeClass('active');
            });
    } else {
        $('.js-vela-search-top').on('click', function(e) {
            e.stopPropagation();
            $(this).addClass('active');
        });
    }
    $('.js-blog-carousel').each(function(){
        $(this).owlCarousel({
            items: 3,
            navigation: true,
            addClassActive: true,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [1025, 2],
            itemsTablet: [767, 1],
            itemsTabletSmall: [480, 1],
            itemsMobile: [360, 1]
        }); 
    });
    $('.js-products-carousel').each(function(){
        $(this).owlCarousel({
            items: 4,
            navigation: true,
            addClassActive: true,
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [1025, 3],
            itemsTablet: [767, 2],
            itemsTabletSmall: [480, 2],
            itemsMobile: [360, 1]
        }); 
    });
    $('.js-influencer-carousel').slick({
        slidesToShow: 3,
        arrows: false,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                  	slidesToShow: 1
                }
            }
        ]
    }); 
    var influencerDrag = false;
    $('.js-influencer-link ').on('mousedown', function(e) {
        var x = e.screenX;
        var y = e.screenY;
        influencerDrag = false;
        $('.js-influencer-link ').on('mousemove', function(e) {
            if (Math.abs(x - e.screenX) > 5 || Math.abs(y - e.screenY) > 5) {
                influencerDrag = true;
            }
        });
    });
    $('.js-influencer-link ').on('mouseup', function(e) {
        $('.js-influencer-link ').off('mousemove');
        e.preventDefault();
        if (!influencerDrag) {
            var url = $(this).data('url');
            window.open(url,'popup','width=600,height=600');
        }
    });
  	$('.ytvideo__thumbnail').on('click', function(event) {
        event.preventDefault();
        var $video = $('.js-ytvideo').find('iframe')[0];
        if ($video.src.indexOf('autoplay') == -1) {
            $video.src += '?autoplay=1';
            $('.js-ytvideo').addClass('is-playing');
        }
    });
    $('.js-collection-sort-by').hover(function() {
        $(this).toggleClass('hover');
    });
    $('.collection-sort-by__heading').on('click', function(e) {
        e.stopPropagation();
        $('.js-collection-sort-by').toggleClass('active');
    });
};
vela.menumobile = (function() {
    var $menu = $('.js-menu-mobile'),
        $toggleMenuMobile = $('.js-toggle-menu-mobile'),
        menuClass = '';
    $toggleMenuMobile.on('click', function() {
        $('body').toggleClass('menu--open');
        $menu.find('.active').removeClass('active');
        $menu.removeClass('mm-links-open--1 mm-links-open--2 mm-links-open--3');
    });
  
    $('.mm-list__nav-open').on('click', function() {
        $menu.removeClass('mm-links-open--1 mm-links-open--2 mm-links-open--3');
        menuClass = 'mm-links-open--' + $(this).data('level');
        $menu.addClass('mm-links-open').addClass(menuClass);
        $(this).parent().addClass('active');
    });
  
    $('.mm-list__nav-back').on('click', function() {
        var menuLevel = $(this).data('level');
        $(this).parent().parent().removeClass('active');
        if (menuLevel == 1) {
            $menu.removeClass('mm-links-open');
            $menu.removeClass('mm-links-open--' + menuLevel);
        } else {
            $menu.removeClass('mm-links-open--' + menuLevel);
        }
    });
})();
vela.filtersmobile = (function() {
    var $slidebar = $('.filters-sidebar'),
        $toggleMenuMobile = $('.js-toggle-filters-mobile');
    $toggleMenuMobile.on('click', function() {
      	if ($('body').hasClass('filters--open')) {
        	$('body').removeClass('filters--open');
          	$toggleMenuMobile.removeClass('active');
        } else {
        	$('body').addClass('filters--open');
          	$toggleMenuMobile.addClass('active');
        }
        //$slidebar.find('.active').removeClass('active');
    });
})();
vela.productPage = function (options) {
    var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector;
    var $addToCart = $('#AddToCart'),
        $productPrice = $('.js-product-price'),
        $comparePrice = $('.js-product-price-compare'),
        $quantityElements = $('.qtySelector, label + .velaJsQty'),
        $addToCartText = $('#AddToCartText');
    if (variant) {
        if (variant.available) {
            $addToCart.removeClass('disabled').prop('disabled', false);
            $addToCartText.html('Add to Cart');
            $quantityElements.show();
        } else {
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html('Sold Out');
            $quantityElements.hide();
        }
        $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
        if (variant.compare_at_price > variant.price) {
            $comparePrice
                .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
                .show();
        } else {
            $comparePrice.hide();
        }
        if (window.swatch_enable) {
            var form = $('#' + selector.domIdPrefix).closest('form');
            for (var i=0,length=variant.options.length; i<length; i++) {
                var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
                if (radioButton.size()) {
                    radioButton.get(0).checked = true;
                }
            }
        }
        if (variant.available) {
            $('.product-detail__attr').removeClass('outstock');
            $('.product-detail__attr').addClass('instock');
            $('.product-detail__attr')
                .html('<label>' + 'Availability' + '</label>: ' + 'In stock');
        } else{
            $('.product-detail__attr').removeClass('instock');
            $('.product-detail__attr').addClass('outstock');
            $('.product-detail__attr').html('<label>' + 'Availability' + '</label>: ' + 'Unavailable');
        }
    } else {
        $addToCart.addClass('disabled').prop('disabled', true);
        $addToCartText.html('Unavailable');
        $quantityElements.hide();
    }
    if (variant && variant.featured_image) {
        var originalImage = $('.slick-current .js-product-image');
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
            $('#ProductThumbs-product-template img').each(function() {
                var idProductImage = $(this).parent().data('id');
                if (idProductImage == newImage.id) {
                    $(this).parent().parent().trigger('click');
                    return false;
                }
            });
        });
    }
};
vela.responsiveVideos = function () {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
    $iframeVideo.each(function () {
      $(this).wrap('<div class="videoContainer"></div>');
    });
    $iframeReset.each(function () {
      this.src = this.src;
    });
};
vela.loginForms = function() {
    function showRecoverPasswordForm() {
      vela.cache.$recoverPasswordForm.show();
      vela.cache.$customerLoginForm.hide();
    }
    function hideRecoverPasswordForm() {
      vela.cache.$recoverPasswordForm.hide();
      vela.cache.$customerLoginForm.show();
    }
  vela.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });
  vela.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });
  if (vela.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};
vela.resetPasswordSuccess = function() {
  vela.cache.$passwordResetSuccess.show();
};
vela.slideShow = function() {
    vela.cache.$velaSlideShow.nivoSlider({
        effect: 'fade',
        slices: 15,
        boxCols: 8,
        boxRows: 4,
        animSpeed: 500,
        pauseTime: 16000,
        startSlide: 0,
        directionNav: true,
        controlNav: true,
        controlNavThumbs: false,
        pauseOnHover: true,
        manualAdvance: false,
        prevText: 'Prev',
        nextText: 'Next',
        randomStart: false,
        beforeChange: function(){},
        afterChange: function(){},
        slideshowEnd: function(){},
        lastSlide: function(){},
        afterLoad: function(){
            $(".slideshowLoading").hide();
        }
    });
};
vela.productImage = function(){
    if (vela.cache.$velaProductImage.length > 0) {
        var zoomYN = vela.cache.$velaProductImage.data('zoom-enable'),
            zoomScroll = vela.cache.$velaProductImage.data('zoom-scroll'),
            zoomType = vela.cache.$velaProductImage.data('zoom-type'),
            zoomWindowWidth = vela.cache.$velaProductImage.data('zoom-width'),
            zoomWindowHeight = vela.cache.$velaProductImage.data('zoom-height'),
            zoomLensSize = vela.cache.$velaProductImage.data('zoom-lens'),
            zoomLensShape = vela.cache.$velaProductImage.data('lens-shape'),
            zoomLensBorderColor = vela.cache.$velaProductImage.data('lens-border');
        vela.cache.$velaProductImage.elevateZoom({
            zoomEnabled: false,
            gallery: 'product-images',
            galleryActiveClass: 'active',
            cursor: 'pointer'
        });
        vela.cache.$velaProductImage.bind('click', function(e) {
            var ez = vela.cache.$velaProductImage.data('elevateZoom');
            $.fancybox(ez.getGalleryList());
            return false;
        });
    }
};
vela.floatHeader = function(){
    function doFloatHeader(status){
        if(status){
            $('#velaHeader').addClass('headerFixed');
            $('#pageContainer').css('padding-top', $('#velaHeader').height());
            var hideheight =  $('#velaHeader').height() + 120;
            var pos = $(window).scrollTop();
            if( pos >= hideheight ){
                $('#velaHeaderMain').addClass('velaHeaderFixed');
            }else {
                $('#velaHeaderMain').removeClass('velaHeaderFixed');
            }
        }
        else{
            $('#velaHeader').removeClass('headerFixed');
            $('#pageContainer').css('padding-top', '');
            $('#velaHeaderMain').removeClass('velaHeaderFixed');
        }
    }
    function velaFloatHeader(){
        if (window.float_header){
            if (($(window).width()) >= 992){
                doFloatHeader(true);
            }
            else if (($(window).width()) <= 991){
                doFloatHeader(false)
            }
        }
    }
    function velaFloatHeaderChange(){
        if (window.float_header){
            if (($(window).width()) >= 992){
                var hideheight =  $('#velaHeader').height() + 120;
                var pos = $(window).scrollTop();
                if( pos >= hideheight ){
                    $('#velaHeaderMain').addClass('velaHeaderFixed');
                }else {
                    $('#velaHeaderMain').removeClass('velaHeaderFixed');
                }
            }
            else if (($(window).width()) <= 991){
                $('#velaHeaderMain').removeClass('velaHeaderFixed');
            }
        }
    }
    velaFloatHeader();
    $(window).resize(velaFloatHeader);
    $(window).scroll(velaFloatHeaderChange);
};
vela.productThumbImage = function(){
    if ($('.js-product-thumbs').length > 0) {
        $('.js-product-thumbs').owlCarousel({
            navigation: true,
            items: 4,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [979, 4],
            itemsTablet: [768, 4],
            itemsTabletSmall: [540, 4],
            itemsMobile: [360, 4]
        });
    }
};
vela.accordion = function(){
    function accordionSidebar(){
        if ( $(window).width() <= 767){
            if(!$('.velaSidebar').hasClass('accordion')){
                $('.velaSidebar .titleSidebar').on('click', function(){
                    $(this).toggleClass('active').parent().find('.velaContent').stop().slideToggle('medium');
                })
            }
            $('.velaSidebar').addClass('accordion').find('.velaContent').slideUp('fast');
        }
        else {
            $('.velaSidebar .titleSidebar').removeClass('active').off().parent().find('.velaContent').removeAttr('style').slideDown('fast');
            $('.velaSidebar').removeClass('accordion');
        }
    }
    function accordionFooter(){
      	$('.footer-menu__title').on('click', function() {
          	$parent = $(this).closest('.footer-menu');
          	$content = $parent.find('.footer-menu__content');
          	if ($(window).width() <= 767) {
              	if ($parent.hasClass('active')) {
                	$parent.removeClass('active');
                    $content.slideUp();
                } else {
                	$parent.addClass('active');
                    $content.slideDown();
                }
            } else {
                $parent.addClass('active');
            	$content.removeAttr('style');
            }
        });
    }    
    function accordionTop(){
        if ( $(window).width() <= 767){
            if(!$('.velaTop').hasClass('accordion')){
                $('.velaTop .current').on('click', function(){
                    $(this).toggleClass('active').parent().find('.toogle_content').stop().slideToggle('medium');
                })
            }
            $('.velaTop').addClass('accordion').find('.toogle_content').slideUp('fast');
        }
        else {
            $('.velaTop .current').removeClass('active').off().parent().find('.toogle_content').removeAttr('style').slideDown('fast');
            $('.velaTop').removeClass('accordion');
        }
    }
    accordionTop();
    $(window).resize(accordionTop);
    //accordionSidebar();
    //$(window).resize(accordionSidebar);
    accordionFooter();
};
vela.ajaxFilter = function(){
    var btnOpenFilter = $('.filterTagFullwidthButton');
    var filterContent = $('.filterTagFullwidthContent');
    vela.cache.$body.on('click', '.filterTagFullwidthButton', function() {
        if (filterContent.hasClass('active')) {
            btnOpenFilter.removeClass('active');
            filterContent.removeClass('active');
            $('.filterTagFullwidthOverlay').each(function() {
                $(this).remove();
            });
        } else {
            $('<div class="filterTagFullwidthOverlay"></div>')
                .css('display', 'none')
                .insertAfter(filterContent);
            $('.filterTagFullwidthOverlay').fadeIn(300);
            btnOpenFilter.addClass('active');
            filterContent.addClass('active');
        }
    });
    vela.cache.$body.on('click', '.filterTagFullwidthOverlay, .filterTagFullwidthClose', function() {
        $('.filterTagFullwidthOverlay').each(function() {
            $(this).remove();
        });
        btnOpenFilter.removeClass('active');
        filterContent.removeClass('active');
    });
    var isAjaxFilterClick =  false;
    if ($(".template-collection")) {
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!isAjaxFilterClick) {
                ajaxFilterParams();
                var newurl = ajaxFilterCreateUrl();
                ajaxFilterGetContent(newurl);
                reActivateSidebar();
            }
            vela.isSidebarAjaxClick = false;
        });
    }
    ajaxFilterParams = function () {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    }
    ajaxFilterGetUrlSubcategory = function (category, url) {
        var str = url;
        var n = str.indexOf(category);
      	if(n < 0) {
          	return '';
      	}
        str = str.slice(n + category.length, str.length);
        var m = str.indexOf('/') > -1 ? str.indexOf('/') : str.length;
        str = str.slice(0, m).toLowerCase();
        return str.replace(name + '=', '');
    },
    ajaxFilterCreateUrl = function(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        if (baseLink) {
            if (newQuery != "")
                return baseLink + "?" + newQuery;
            else
                return baseLink;
        }
        return location.pathname + "?" + newQuery;
    }
    ajaxFilterClick = function(baseLink) {
        delete Shopify.queryParams.page;
        var newurl = ajaxFilterCreateUrl(baseLink);
        isAjaxFilterClick = true;
        History.pushState({
            param: Shopify.queryParams
        }, newurl, newurl);
        ajaxFilterGetContent(newurl);
    }
    ajaxFilterSortby = function() {
        if (Shopify.queryParams.sort_by) {
            var sortby = Shopify.queryParams.sort_by;
          	$('.collection-sort-by__item').removeClass('active');
            $('.collection-sort-by__item[data-value="' + sortby + '"]').addClass('active');
        }
        vela.cache.$body.on('click', '.collection-sort-by__item', function(event) {
            event.stopPropagation();
            Shopify.queryParams.sort_by = $(this).data('value');
            $('.collection-sort-by__item').removeClass('active');
            $(this).addClass('active');
            ajaxFilterClick();
        });
    }
    ajaxFilterView = function() {
        vela.cache.$body.on('click', '.changeView', function(event) {
            event.preventDefault();
            if (!$(this).hasClass("changeViewActive")) {
                Shopify.queryParams.view = $(this).data('view');
                $(".changeView").removeClass('changeViewActive');
                $(this).addClass('changeViewActive');
                ajaxFilterClick();
            }
        });
    }
    ajaxFilterTags = function(){
        vela.cache.$body.on('click', '.ajaxFilter li > a', function(event) {
            event.preventDefault();
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
                currentTags = Shopify.queryParams.constraint.split('+');
            }
            var location_path = location.pathname;
            var location_search = location.search;
            var path_search = location_path.split('/');
            path_search.length > 3 ? path_search = path_search.pop().replace(/&/g, '') : path_search = '';
          	if (path_search != '') {
            	currentTags.push(path_search);
            }
            if (!window.sidebar_multichoise && !$(this).parent().hasClass("active")) {
                var otherTag = $(this).parents('.listFilter').find("li.active");
                if (otherTag.length > 0) {
                    var tagName = otherTag.data("filter");
                    if (tagName) {
                        var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                            currentTags.splice(tagPos, 1);
                        }
                    }
                }
            }
            var dataHandle = $(this).parent().data("filter");
            if (dataHandle.indexOf('capacity_') >= 0) {
                var otherTag = $(this).parents('.listFilter').find("li.active");
                if (otherTag.length > 0) {
                    var tagName = otherTag.data("filter");
                    if (tagName) {
                        var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                            currentTags.splice(tagPos, 1);
                        }
                    }
                }
            }
            if (dataHandle) {
                var tagPos = currentTags.indexOf(dataHandle);
                if (tagPos >= 0) {
                    currentTags.splice(tagPos, 1);
                } else {
                    currentTags.push(dataHandle);
                }
            }
            if (currentTags.length) {
                Shopify.queryParams.constraint = currentTags.join('+');
            } else {
                delete Shopify.queryParams.constraint;
            }
          	if (path_search != '') {
          		var collectionURL = '/collections/' + ajaxFilterGetUrlSubcategory('/collections/', location.pathname);
                ajaxFilterClick(collectionURL);
            } else {
              	ajaxFilterClick();
            }
        });
    }
    ajaxFilterPaging = function() {
        vela.cache.$body.on('click', '#collPagination .pagination a', function(event){
            event.preventDefault();
            var linkPage = $(this).attr("href").match(/page=\d+/g);
            if (linkPage) {
                Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
                if (Shopify.queryParams.page) {
                    var newurl = ajaxFilterCreateUrl();
                    isAjaxFilterClick = true;
                    History.pushState({
                        param: Shopify.queryParams
                    }, newurl, newurl);
                    ajaxFilterGetContent(newurl);
                    $('body,html').animate({
                        scrollTop: 300
                    }, 600);
                }
            }
        });
    }
    ajaxFilterReview = function() {
        if (window.review){
            if ($(".shopify-product-reviews-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            };
        }
    }
    ajaxFilterClear = function() {
        $(".ajaxFilter").each(function() {
            var sidebarTag = $(this);
            if (sidebarTag.find(".listFilter > li.active").length > 0) {
                sidebarTag.find(".velaClear").show().click(function(e) {
                    var currentTags = [];
                    if (Shopify.queryParams.constraint) {
                        currentTags = Shopify.queryParams.constraint.split('+');
                    }
                    sidebarTag.find(".listFilter > li.active").each(function() {
                        var selectedTag = $(this);
                        var tagName = selectedTag.data("filter");
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    });
                    if (currentTags.length) {
                        Shopify.queryParams.constraint = currentTags.join('+');
                    } else {
                        delete Shopify.queryParams.constraint;
                    }
                    ajaxFilterClick();
                    e.preventDefault();
                });
            }
        });
    }
    ajaxFilterClearAll = function() {
        vela.cache.$body.on('click', 'a.js-filter-clearall', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
          	var location_path = location.pathname;
            var location_search = location.search;
            var path_search = location_path.split('/');
            path_search.length > 3 ? path_search = path_search.pop().replace(/&/g, '') : path_search = '';
          	if (path_search != '') {
          		var collectionURL = '/collections/' + ajaxFilterGetUrlSubcategory('/collections/', location.pathname);
                ajaxFilterClick(collectionURL);
            } else {
              	ajaxFilterClick();
            }
            e.preventDefault();
        });
    }
    ajaxFilterAddToCart = function(){
        if (window.ajaxcart_type != "page"){
            ajaxCart.init({
                formSelector: '.formAddToCart',
                cartContainer: '#cartContainer',
                addToCartSelector: '.btnAddToCart',
                cartCountSelector: '#CartCount',
                cartCostSelector: '#CartCost',
                moneyFormat: null
            });
        }
    }
    ajaxAccordionMobile = function(){
        if($('.velaSidebar').hasClass('accordion')){
            $('#sidebarAjaxFilter .titleSidebar').on('click', function(e){
                $(this).toggleClass('active').parent().find('.velaContent').stop().slideToggle('medium');
                e.preventDefault();
            });
        }
    }
    ajaxFilterData = function(data){
        var currentList = $("#proListCollection .proList");
        var dataList = $(data).find("#proListCollection .proList");
        currentList.replaceWith(dataList);
        if ($("#collPagination").length > 0) {
            $("#collPagination").replaceWith($(data).find("#collPagination"));
        } else {
            $("#shopify-section-vela-template-collection").append($(data).find("#collPagination"));
        }
      	if ($('.tags--collection').length > 0) {
        	$('.tags--collection').replaceWith($(data).find('.tags--collection'));
        }
        var currentSidebarFilter = $("#sidebarAjaxFilter");
        var dataSidebarFilter = $(data).find("#sidebarAjaxFilter");
        currentSidebarFilter.replaceWith(dataSidebarFilter);
    }
    ajaxFilterGetContent = function(newurl) {
        $.ajax({
            type: 'get',
            url: newurl,
            beforeSend: function() {
                vela.cache.$velaLoading.show();
            },
            success: function(data) {
                var newTitle = $(data).filter('title').text();
                document.title = newTitle;
                ajaxFilterData(data);
                ajaxFilterSortby();
                ajaxFilterReview();
                ajaxFilterClear();
                ajaxFilterAddToCart();
                ajaxAccordionMobile();
                vela.cache.$velaLoading.hide();
            },
            error: function(xhr, text) {
                vela.cache.$velaLoading.hide();

            }
        });
    }
    ajaxFilterParams();
    ajaxFilterSortby();
    ajaxFilterView();
    ajaxFilterTags();
    ajaxFilterPaging();
    ajaxFilterClear();
    ajaxFilterClearAll();
};
vela.productCountdown = function() {
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime(window.countdown_format));
      });
    });
};
vela.gotop = function() {
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 800) {
            $('#gotop').fadeIn();
        } else {
            $('#gotop').fadeOut();
        }
    });
    $("#gotop").click(function(){
        $("body,html").animate({scrollTop:0 },"normal");
        $("#pageContainer").animate({scrollTop:0 },"normal");
            return!1
    });
}
vela.wishlist = function(){
    function postToWishlist() {
        $(".wishlistForm").submit(function(e) {
            e.preventDefault();
            var postData = $(this).serializeArray();
            var formURL = $(this).attr("action");
            var d = $(this).parent();
            $.ajax({
                url : formURL,
                type: "POST",
                data : postData,
                beforeSend: function() {
                    $('#loading').show();
                },
                success:function(data, textStatus) {
                    console.log(textStatus);
                    $('#loading').hide();
                    d.empty().html('<a class="btn btnProduct btnWishlistAdded added" href="' + window.wishlist_url + '"><i class="fa fa-heart-o"></i><span>Added to wishlist</span></a>');
                    btnWishlist();
                    if (!!$.prototype.fancybox)
                        $.fancybox.open([{
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: '<div class="wishlistAlert"><div class="alert alert-success">' + 'Added to your wishlist.' + '<a href="' + window.wishlist_url + '">Go To Wishlist</a>' + '</div></div>'
                        }], {
                            padding: 0
                        });
                    else
                        alert('Added to your wishlist.');
                },
                error: function() {
                    $('#loading').hide();
                    if (!!$.prototype.fancybox)
                        $.fancybox.open([{
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: '<p class="fancybox-error">I`m afraid that did not work</p>'
                        }], {
                            padding: 0
                        });
                    else
                        alert('I`m afraid that did not work');
                }
            });
        });
    }
    function removeFromWishlist($this) {
        var $elem = $this.closest("tr");
        var tagID = $elem.attr("id");
        var $form = $("#removeWishlist");
        $("#remove-value").attr("value", tagID);
        var postData = $form.serializeArray();
        var formURL = $form.attr("action");
        $.ajax({
            url : formURL,
            type: "POST",
            data : postData,
            beforeSend: function() {
                $('#loading').show();
            },
            success:function(data, textStatus) {
                console.log(textStatus);
                $('#loading').hide();
                $elem.remove();
                if($(".wishlist-product tbody tr").length == 0) {
                    $("#wishlist-email-link").empty().html("<p>Your wish list is currently empty.</p>");
                } else {
                    updateEmailList();
                }
            },
            error: function() {
                $('#loading').hide();
                if (!!$.prototype.fancybox)
                    $.fancybox.open([{
                        type: 'inline',
                        autoScale: true,
                        minHeight: 30,
                        content: '<p class="fancybox-error">I`m afraid that did not work</p>'
                    }], {
                        padding: 0
                    });
                else
                    alert('I`m afraid that did not work');
            }
        });
    }
    function updateEmailList() {
        var currentURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
        $.ajax({
            url : currentURL,
            type: "GET",
            success:function(data, textStatus) {
                console.log(textStatus);
                var newEmailLink = $(data).find("#wishlist-email-link a");
                $("#wishlist-email-link").html(newEmailLink);
            }
        });
    }
    function btnWishlist(){
        $('.btnRemoveWishlist').on('click', function(e) {
            e.preventDefault();
            removeFromWishlist($(this));
        });
        $('.btnWishlistNoLog').on('click', function(e){
            e.preventDefault();
            if (!!$.prototype.fancybox)
                $.fancybox.open([{
                    type: 'inline',
                    autoScale: true,
                    minHeight: 30,
                    content: '<div class="wishlistAlert"><div class="alert alert-info">' + 'You must be logged in to manage your wishlist. <a href="/account">Login here.</a>' + '</div></div>'
                }], {
                    padding: 0
                });
            else
              alert('You must be logged in to manage your wishlist. <a href="/account">Login here.</a>');
        });
        $('.btnWishlistAdded').on('click', function(e){
            e.preventDefault();
            if (!!$.prototype.fancybox)
                $.fancybox.open([{
                    type: 'inline',
                    autoScale: true,
                    minHeight: 30,
                    content: '<div class="wishlistAlert"><div class="alert alert-success">' + 'Added to your wishlist.' + '<a href="' + window.wishlist_url + '">Go To Wishlist</a>' + '</div></div>'
                }], {
                    padding: 0
                });
            else
              alert('Added to your wishlist.');
        });
    }
    postToWishlist();
    btnWishlist();
};
vela.quickview = function(){
    var product = {};
    var option1 = '';
    var option2 = '';
    Shopify.doNotTriggerClickOnThumb = false;
    selectCallbackQuickView = function(variant, selector) {
        var productItem = jQuery('.jsQuickview .proBoxInfo'),
            addToCart = productItem.find('.btnAddToCart'),
            productPrice = productItem.find('.pricePrimary'),
            comparePrice = productItem.find('.priceCompare');
        if (variant) {
            if (variant.available) {
                addToCart.removeClass('disabled').removeAttr('disabled');
                $(addToCart).find("span").text("Add to Cart");
            } else {
                addToCart.addClass('disabled').attr('disabled', 'disabled');
                $(addToCart).find("span").text("Sold Out");
            }       
            productPrice.html(Shopify.formatMoney(variant.price, ""));
            if ( variant.compare_at_price > variant.price ) {
                comparePrice
                    .html(Shopify.formatMoney(variant.compare_at_price, "")).show();
            } else {
                comparePrice.hide();
            }
            
            if (variant && variant.featured_image) {
                var originalImage = $(".proImageQuickview");
                var newImage = variant.featured_image;
                var element = originalImage[0];
                Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
                    $('.proThumbnails img').each(function() {
                        var parentThumbImg = $(this).parent();
                        var productImage = $(this).parent().data("image");
                        if (newImageSizedSrc.includes(productImage)) {
                            $(this).parent().trigger('click');
                            return false;
                        }
                    });
                });
            }
        } else {
            addToCart.addClass('disabled').attr('disabled', 'disabled');
            $(addToCart).find("span").text("Sold Out");
        }
    }
    changeImageQuickView = function (img, selector) {
        var src = $(img).attr("src");
        src = src.replace("_compact", "");
        $(selector).attr("src", src);
    }
    velaUpdateOptionsInSelector = function (t) {
        switch (t) {
        case 0:
            var n = "root";
            var r = $(".jsQuickview .single-option-selector:eq(0)");
            break;
        case 1:
            var n = $(".jsQuickview .single-option-selector:eq(0)").val();
            var r = $(".jsQuickview .single-option-selector:eq(1)");
            break;
        case 2:
            var n = $(".jsQuickview .single-option-selector:eq(0)").val();
            n += " / " + $(".jsQuickview .single-option-selector:eq(1)").val();
            var r = $(".jsQuickview .single-option-selector:eq(2)")
        }
        var i = r.val();
        r.empty();
        var s = Shopify.optionsMapQuickview[n];
        if(typeof s != "undefined"){
            for (var o = 0; o < s.length; o++) {
                var u = s[o];
                var a = $("<option></option>").val(u).html(u);
                r.append(a)
            }
        }
        $('.jsQuickview .swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
            if ($.inArray($(this).attr("data-value"), s) !== -1) {
                $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled");
            } else {
                //$(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
            }
        });
        if ($.inArray(i, s) !== -1) {
            r.val(i)
        }
        r.trigger("change")
    }
    velaLinkOptionSelectors = function (t) {
        for (var n = 0; n < t.variants.length; n++) {
            var r = t.variants[n];
            if (r.available) {
                Shopify.optionsMapQuickview["root"] = Shopify.optionsMapQuickview["root"] || [];
                Shopify.optionsMapQuickview["root"].push(r.option1);
                Shopify.optionsMapQuickview["root"] = Shopify.uniq(Shopify.optionsMapQuickview["root"]);
                if (t.options.length > 1) {
                    var i = r.option1;
                    Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                    Shopify.optionsMapQuickview[i].push(r.option2);
                    Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
                }
                if (t.options.length === 3) {
                    var i = r.option1 + " / " + r.option2;
                    Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                    Shopify.optionsMapQuickview[i].push(r.option3);
                    Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
                }
            }
        }
        velaUpdateOptionsInSelector(0);
        if (t.options.length > 1)
            velaUpdateOptionsInSelector(1);
        if (t.options.length === 3)
            velaUpdateOptionsInSelector(2);
        $(".single-option-selector:eq(0)").change(function() {
            velaUpdateOptionsInSelector(1);
            if (t.options.length === 3)
                velaUpdateOptionsInSelector(2);
            return true
        });
        $(".single-option-selector:eq(1)").change(function() {
            if (t.options.length === 3)
                velaUpdateOptionsInSelector(2);
            return true
        });
    }
    loadQuickViewSlider = function (n, r) {
        var loadingImgQuickView = $('.loadingImage');
        var s = Shopify.resizeImage(n.featured_image, "grande");
        loadingImgQuickView.hide();
        if (n.images.length > 0) {
            var o = r.find(".proThumbnailsQuickview .owl-carousel");
            for ( var i=0; i < n.images.length; i++) {
                var u = Shopify.resizeImage(n.images[i], "grande");
                var a = Shopify.resizeImage(n.images[i], "compact");
                var f = '<div class="thumbItem"><a href="javascript:void(0)" data-imageid="' + n.id + '" data-image="' + n.images[i] + '" data-zoom-image="' + u + '" ><img src="' + a + '" alt="Produc Image" /></a></div>';
                o.append(f)
            }
            o.find("a").click(function() {
                var t = r.find(".proImageQuickview");
                if (t.attr("src") != $(this).attr("data-image")) {
                    t.attr("src", $(this).attr("data-image"));
                    loadingImgQuickView.show();
                    t.load(function(t) {
                        $(this).unbind("load");
                        loadingImgQuickView.hide()
                    })
                }
            });
            o.owlCarousel({
                navigation: true,
                items: 5,
                itemsDesktop: [1199, 4],
                itemsDesktopSmall: [979, 4],
                itemsTablet: [768, 4],
                itemsTabletSmall: [540, 4],
                itemsMobile: [360, 4]
            }).css("visibility", "visible")
        } else {        
            r.find(".jsQuickview .proThumbnailsQuickview").remove();
        }
    }
    convertToSlug = function (e) {
        return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
    }
    addCheckedSwatch = function (){  
        $('.swatch .color label').on('click', function () {      
            $('.swatch .color').each(function(){      
                $(this).find('label').removeClass('checkedBox');
            });
            $(this).addClass('checkedBox');
        });
    }
    quickViewVariantsSwatch = function (t, quickview) {
        if (t.variants.length > 1) {
            for (var r = 0; r < t.variants.length; r++) {
                var i = t.variants[r];
                var s = '<option value="' + i.id + '">' + i.title + "</option>";
                quickview.find("form.formQuickview .proVariantsQuickview > select").append(s)
            }
            new Shopify.OptionSelectors( 'productSelectQuickview', { 
                product: t, 
                onVariantSelected: selectCallbackQuickView
            });
            if (t.options.length == 1) {
                $("form.formQuickview .selector-wrapper:eq(0)").prepend("<label>" + t.options[0].name + "</label>")
            }
            quickview.find("form.formQuickview .selector-wrapper label").each(function(n, r) {
                $(this).html(t.options[n].name)
            })
            
            if (t.available) {
                Shopify.optionsMapQuickview = {};
                velaLinkOptionSelectors(t);
            }
        }
        else {
            quickview.find("form.formQuickview .proVariantsQuickview > select").remove();
            var v = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
            quickview.find("form.formQuickview").append(v)
        }
    }
    validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {

        } else {
            qty = 1;
        }
        return qty;
    };
    $(document).on("click", ".proThumbnailsQuickview li", function() {
        changeImageQuickView($(this).find("img:first-child"), ".proImageQuickview");
    });
    $(document).on('click', '.quickviewClose, .quickviewOverlay', function(e){
        $("#velaQuickView").fadeOut(500);
        $(".jsQuickview").html("");
        $(".jsQuickview").fadeOut(500);
    });
    $(document).on('click', '.btnProductQuickview', function(e){
        $('#loading').show();
        var producthandle = $(this).data("handle");
        Shopify.getProduct(producthandle,function(product) {
            var qvhtml = $("#quickviewModal").html();
            $(".jsQuickview").html(qvhtml);
            var quickview= $(".jsQuickview");
            var productdes = product.description.replace(/(<([^>]+)>)/ig,"");
            var featured_image = product.featured_image;
            productdes = productdes.split(" ").splice(0,30).join(" ")+"...";
            quickview.find(".proImageQuickview").attr("src",featured_image);
            quickview.find(".pricePrimary").html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find(".proBoxInfo").attr("id", "product-" + product.id);
            quickview.find(".formQuickview").attr("id", "product-actions-" + product.id);
            quickview.find(".formQuickview select").attr("id", "productSelectQuickview");
            quickview.find(".proBoxInfo .quickviewName").text(product.title);
            quickview.find(".proBoxInfo .quickViewVendor").append("<label>Vendor</label>: " + product.vendor);
            if(product.available){
                quickview.find(".proBoxInfo .quickviewAvailability").append("<label>Availability</label>: In stock");
            }else{
                quickview.find(".proBoxInfo .quickviewAvailability").append("Availability</label>: Unavailable");
            }
            quickview.find(".proShortDescription").text(productdes);
            if (product.compare_at_price > product.price) {
                quickview.find(".priceCompare").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
            }
            else {
                quickview.find(".priceCompare").html("");
            }
            if (!product.available) {
                quickview.find("select, input, .dec, .inc").remove();
                quickview.find(".btnAddToCart").text("Sold Out").addClass("disabled").attr("disabled", "disabled");
                $(".proQuantity").css("display", "none");
            }
            else {
                quickViewVariantsSwatch(product, quickview);
            }
            loadQuickViewSlider(product, quickview);
            $('#velaQuickView').fadeIn(500);
            $('.jsQuickview').fadeIn(500);
            $('#loading').hide();
            $('.velaQtyAdjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.velaQtyNum'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));
                var qty = validateQty(qty);
                if ($el.hasClass('velaQtyAdjustPlus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }
                $qtySelector.val(qty);
            });
        });
        return false;
    });
};
vela.owlOneCarousel = function(){
    $(".owlCarouselPlay .owl-carousel").each(function(){
        var owlCarousel = $(this);
        var navigation = owlCarousel.data("nav"),
            autoplay = owlCarousel.data("autoplay"),
            autospeed = owlCarousel.data("autospeed"),
            pagination = owlCarousel.data("pagination"),
            speed = owlCarousel.data("speed"),
            columnOne = owlCarousel.data("columnone"),
            columnTwo = owlCarousel.data("columntwo"),
            columnThree = owlCarousel.data("columnthree"),
            columnFour = owlCarousel.data("columnfour"),
            columnFive = owlCarousel.data("columnfive");
            if (!columnFive) {
               columnFive = 1;
            }            

        var config = {
            items: columnOne,
            itemsDesktop: [1199, columnTwo],
            itemsDesktopSmall: [991, columnThree],
            itemsTablet: [767, columnFour],
            itemsTabletSmall: [479, 1],
            itemsMobile: [0, 1],
            responsiveClass:true,
            responsive:{
                0:{
                    items:columnFive
                },
                479:{
                    items:columnFour
                },
                767:{
                    items:columnFour
                },
                991:{
                    items:columnThree
                },
                1199:{
                    items:columnOne
                }
            },
            navigation: navigation,
            dots: false,
            smartSpeed: speed,
            afterInit: RemoveLoading
        };
        if(pagination) {
            config.dots = true;
        }
        if (autoplay){
            config.autoplay = autoplay;
            config.autoplaySpeed = autospeed;
        }
        owlCarousel.owlCarousel( config );

        function RemoveLoading(el){
            el.parents('.proOwlCarousel').removeClass('proLoading');
        }
        function FirstLastActiveItem(el){
            el.find(".owl-item").removeClass("first");
            el.find(".owl-item.active").first().addClass("first");
            el.find(".owl-item").removeClass("last");
            el.find(".owl-item.active").last().addClass("last");
        }
    });
};
vela.Drawers = (function () {
    var Drawer = function (id, position, iscart, options) {
      var defaults = {
          close: '.jsDrawerClose',
          open: '.jsDrawerOpen' + position,
          openClass: 'jsDrawerOpen',
          dirOpenClass: 'jsDrawerOpen' + position
      };
      this.$nodes = {
          parent: $('body, html'),
          page: $('#pageContainer'),
          moved: $('.isMoved')
      };
      this.config = $.extend(defaults, options);
      this.position = position;
        this.iscart = iscart;
      this.$drawer = $('#' + id);
      if (!this.$drawer.length) {
          return false;
      }
      this.drawerIsOpen = false;
      this.init();
    };
  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };
    Drawer.prototype.open = function (evt) {
      if (window.ajaxcart_type == 'modal' && this.iscart ) {
        var externalCall = false;
        this.$drawer.modal();//Use modal Bootstrap
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.$activeSource = $(evt.currentTarget);
      }
      if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
        if (!externalCall) {
          this.config.onDrawerOpen();
        }
      }
      } else {
      var externalCall = false;
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.$activeSource = $(evt.currentTarget);
      }
      if (this.drawerIsOpen && !externalCall) {
        return this.close();
      }
        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();
        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        this.trapFocus(this.$drawer, 'drawer_focus');
      if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
        if (!externalCall) {
          this.config.onDrawerOpen();
        }
      }
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
      this.$nodes.page.on('touchmove.drawer', function () {
        return false;
      });
      this.$nodes.page.on('click.drawer', $.proxy(function () {
        this.close();
        return false;
      }, this));
      }
    };
    Drawer.prototype.close = function () {
      if (!this.drawerIsOpen) { // don't close a closed drawer
          return;
      }
      $(document.activeElement).trigger('blur');
      this.$nodes.moved.prepareTransition({ disableExisting: true });
      this.$drawer.prepareTransition({ disableExisting: true });
      this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
      this.drawerIsOpen = false;
      this.removeTrapFocus(this.$drawer, 'drawer_focus');
      this.$nodes.page.off('.drawer');
    };
  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.attr('tabindex', '-1');
    $container.focus();
    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };
  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };
  return Drawer;
})();
vela.loadingSite = function(){
    $('body').removeClass('bodyPreLoading');
    $('#loadingSite').fadeOut();
};
vela.filterByPrice = function(){
    var $range = $("#rangePrice");
    var $btnFilter = $(".btnFilterPrice");
    var minPrice = 0;
    var maxPrice = 0;
    function processFilterPrice(minPrice, maxPrice){
        $('#loading').show();
        $("#velaProList .velaFlexRow .velaProItem").hide().filter(function() {
            var price = parseInt($(this).data("price"), 10);
            console.log('Min: ' + minPrice);
            console.log('Max: ' + maxPrice);
            console.log('Price: ' + price);
            return price >= minPrice && price <= maxPrice;
        }).show();
        $('body,html').animate({
            scrollTop: 400
        }, 600);
        setTimeout( function() {
            $('#loading').hide();
        }, 200 );
        
    };
    $btnFilter.on("click", function () {
        minPrice = $range.data("from"),
        maxPrice = $range.data("to");
        console.log(minPrice + " - " + maxPrice);
        processFilterPrice(minPrice,maxPrice);
    });
    $range.ionRangeSlider({
        onFinish: function (data) {
            //processFilterPrice(minPrice,maxPrice);
        }
    });
};
      
vela.disclosure = function() {
  var $disclosure = $('.js-disclosure');
  $disclosure.each(function() {
    var $disclosureOptions = $(this).find('.js-disclosure-item'),
        $disclosureInput = $(this).find('.js-disclosure-input');

    $disclosureOptions.on('click', function(evt) {
      evt.preventDefault();
      var value = $(this).data('value');
      $disclosureInput.val(value);
      $(this).closest('form').submit();
    });
  });
};

$(document).ready(function() {
    $(vela.init);
    vela.disclosure();
    $('body').on('ajaxCart.afterCartLoad', function(evt, cart) {
        if (window.ajaxcart_type == 'drawer') {
            vela.RightDrawer.open();
        }
    });
    var sections = new velatheme.Sections();
    sections.register('velaSlideshowSection', velatheme.SlideshowSection);
  	sections.register('product-template', velatheme.Product);
  	$('.js-product-detail-image').fancybox({
      	nextEffect: 'none',
      	prevEffect: 'none'
    });
});
$(window).load(function() {
    //$(vela.slideShow);
    $(vela.productImage);
    $(vela.loadingSite);
    $( window ).resize(function() {
        vela.productImage(); 
    });
});

window.velatheme = window.velatheme || {};
velatheme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
};
velatheme.Sections.prototype = _.assignIn({}, velatheme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });
        this.instances.push(instance);
    },
    register: function(type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});
velatheme.Slideshow = (function() {
    this.$slideshow = null;
    var classes = {
        wrapper: 'velaSlideshowWrapper',
        slideshow: 'vela--slideshow',
        currentSlide: 'slick-current',
        video: 'velassVideo',
        videoBackground: 'velassVideoBackground',
        closeVideoBtn: 'btnssVideoControlClose',
        pauseButton: 'btnssPause',
        isPaused: 'is-paused'
    };

    function slideshow(el) {
        this.$slideshow = $(el);
        this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
        this.$pause = this.$wrapper.find('.' + classes.pauseButton);
        this.settings = {
            accessibility: true,
            arrows: this.$slideshow.data('navigation'),
            dots: this.$slideshow.data('pagination'),
            fade: true,
            pauseOnHover: true,
            draggable: true,
            touchThreshold: 20,
            autoplay: this.$slideshow.data('autoplay'),
            autoplaySpeed: this.$slideshow.data('speed')
        };
        this.$slideshow.on('beforeChange', beforeChange.bind(this));
        this.$slideshow.on('init', slideshowA11y.bind(this));
        this.$slideshow.slick(this.settings);
        this.$pause.on('click', this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;
        $slider.removeClass('velaSliderLoading');
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
        // When an element in the slider is focused
        // pause slideshow and set aria-live.
        $wrapper.on('focusin', function(evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr('aria-live', 'polite');
            if (autoplay) {
                $slider.slick('slickPause');
            }
        });
        //Resume autoplay
        $wrapper.on('focusout', function(evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr('aria-live');
            if (autoplay) {
                // Manual check if the focused element was the video close button
                // to ensure autoplay does not resume when focus goes inside YouTube iframe
                if ($(evt.target).hasClass(classes.closeVideoBtn)) {
                  return;
                }
                $slider.slick('slickPlay');
            }
        });
        // Add arrow key support when focused
        if (obj.$dots) {
            obj.$dots.on('keydown', function(evt) {
                if (evt.which === 37) {
                    $slider.slick('slickPrev');
                }
                if (evt.which === 39) {
                    $slider.slick('slickNext');
                }
                // Update focus on newly selected tab
                if ((evt.which === 37) || (evt.which === 39)) {
                    obj.$dots.find('.slick-active button').focus();
                }
            });
        }
    };
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide);
        var $nextSlide = $slider.find('.velassSlide[data-slick-index="' + nextSlide + '"]');
        if (isVideoInSlide($currentSlide)) {
            var $currentVideo = $currentSlide.find('.' + classes.video);
            var currentVideoId = $currentVideo.attr('id');
            velatheme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr('tabindex', '-1');
        }
        if (isVideoInSlide($nextSlide)) {
            var $video = $nextSlide.find('.' + classes.video);
            var videoId = $video.attr('id');
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground) {
                velatheme.SlideshowVideo.playVideo(videoId);
            } else {
                $video.attr('tabindex', '0');
            }
        }
    }
    function isVideoInSlide($slide) {
        return $slide.find('.' + classes.video).length;
    }
    slideshow.prototype.togglePause = function() {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick('slickPlay');
        } else {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick('slickPause');
        }
    };
    function getSlideshowId($el) {
        return '#velaSlideshows' + $el.data('id');
    }
    return slideshow;
})();
// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
    velatheme.SlideshowVideo.loadVideos();
}
velatheme.SlideshowVideo = (function() {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: {
            // eslint-disable-next-line camelcase
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange
        }
    };
    var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        slideshowWrapper: 'velaSlideshowWrapper',
        slide: 'velassSlide',
        slideBackgroundVideo: 'velassSlideBackgroundVideo',
        slideDots: 'slick-dots',
        videoChrome: 'velassVideo-chrome',
        videoBackground: 'velassVideoBackground',
        playVideoBtn: 'btnssVideoControlPlay',
        closeVideoBtn: 'btnssVideoControlClose',
        currentSlide: 'slick-current',
        slickClone: 'slick-cloned',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay'
    };
    function init($video) {
        if (!$video.length) {
            return;
        }

        videos[$video.attr('id')] = {
            id: $video.attr('id'),
            videoId: $video.data('id'),
            type: $video.data('type'),
            status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
            videoSelector: $video.attr('id'),
            $parentSlide: $video.closest('.' + classes.slide),
            $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
            controls: $video.data('type') === 'background' ? 0 : 1,
            slideshow: $video.data('slideshow')
        };
        if (!youtubeLoaded) {
            // This code loads the IFrame Player API code asynchronously.
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function loadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;

        if (playOnClick) {
            // playOnClick means we are probably on mobile (no autoplay).
            // setAsPlaying will show the iframe, requiring another click
            // to play the video.
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
            // Play if autoplay is available or clicked to play
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }
        // Check for autoplay if not already done
        if (!autoplayCheckComplete) {
            autoplayCheckFunction(player, $slide);
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $slide) {
        // attempt to play video
        player.playVideo();
        autoplayTest(player)
            .then(function() {
                setAutoplaySupport(true);
            })
            .fail(function() {
                // No autoplay available (or took too long to start playing).
                // Show fallback image. Stop video for safety.
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function() {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }
    function autoplayTest(player) {
        var deferred = $.Deferred();
        var wait;
        var timeout;
        wait = setInterval(function() {
            if (player.getCurrentTime() <= 0) {
                return;
            }
            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);
        timeout = setTimeout(function() {
            clearInterval(wait);
            deferred.reject();
        }, 4000); // subjective. test up to 8 times over 4 seconds
        return deferred;
    }
    function playOnClickCheck() {
        // Bail early for a few instances:
        // - small screen
        // - device sniff mobile browser
        if (playOnClickChecked) {
            return;
        }
        if ($(window).width() < 750) {
            playOnClick = true;
        }
        if (playOnClick) {
            // No need to also do the autoplay check
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    // The API will call this function when each video player is ready
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);
        playOnClickCheck();
        // Prevent tabbing through YouTube player controls until visible
        $('#' + videoData.id).attr('tabindex', '-1');
        sizeBackgroundVideos();
        // Customize based on options from the video ID
        switch (videoData.type) {
            case 'background-chrome':
            case 'background':
                evt.target.mute();
                // Only play the video if it is in the active slide
                if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
                    privatePlayVideo(videoData.id);
                }
                break;
        }
        videoData.$parentSlide.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        switch (evt.data) {
            case 0: // ended
                setAsFinished(videoData);
                break;
            case 1: // playing
                setAsPlaying(videoData);
                break;
            case 2: // paused
                setAsPaused(videoData);
                break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
            case 'background':
                videoPlayers[videoData.id].seekTo(0);
                break;
            case 'background-chrome':
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
              break;
            case 'chrome':
                closeVideo(videoData.id);
                break;
        }
    }
    function setAsPlaying(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        $slide.removeClass(classes.loading);
        // Do not change element visibility if it is a background video
        if (videoData.status === 'background') {
            return;
        }
        $('#' + videoData.id).attr('tabindex', '0');
            switch (videoData.type) {
                case 'chrome':
                case 'background-chrome':
                    $slideshow
                      .removeClass(classes.paused)
                      .addClass(classes.playing);
                    $slide
                      .removeClass(classes.paused)
                      .addClass(classes.playing);
                    break;
            }
            // Update focus to the close button so we stay within the slide
            $slide.find('.' + classes.closeVideoBtn).focus();
    }
    function setAsPaused(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        if (videoData.type === 'background-chrome') {
            closeVideo(videoData.id);
            return;
        }
        // YT's events fire after our click event. This status flag ensures
        // we don't interact with a closed or background video.
        if (videoData.status !== 'closed' && videoData.type !== 'background') {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }
        if (videoData.type === 'chrome' && videoData.status === 'closed') {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }
        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(' ');
        $('#' + videoData.id).attr('tabindex', '-1');
        videoData.status = 'closed';
        switch (videoData.type) {
            case 'background-chrome':
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case 'chrome':
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData); // in case the video is already paused
                break;
        }
        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.target.options.id];
    }
    function startVideoOnClick(playerId) {
        var videoData = videos[playerId];
        // add loading class to slide
        videoData.$parentSlide.addClass(classes.loading);
        videoData.status = 'open';
        switch (videoData.type) {
            case 'background-chrome':
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case 'chrome':
                privatePlayVideo(playerId, true);
                break;
        }
        // esc to close video player
        $(document).on('keydown.videoPlayer', function(evt) {
            if (evt.keyCode === 27) {
                closeVideo(playerId);
            }
        });
    }
    function sizeBackgroundVideos() {
        $('.' + classes.videoBackground).each(function(index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($player) {
        var $slide = $player.closest('.' + classes.slide);
        // Ignore cloned slides
        if ($slide.hasClass(classes.slickClone)) {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();
        // when screen aspect ratio differs from video, video must center and underlay one dimension
        if (slideWidth / videoOptions.ratio < playerHeight) {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
            $player.width(playerWidth).height(playerHeight).css({
                left: (slideWidth - playerWidth) / 2,
                top: 0
            }); // player width is greater, offset left; reset top
        } else { // new video width < window width (gap to right)
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
            $player.width(slideWidth).height(playerHeight).css({
                left: 0,
                top: (playerHeight - playerHeight) / 2
            }); // player height is greater, offset top; reset left
        }
        $player
            .prepareTransition()
            .addClass(classes.loaded);
    }
    function unsetBackgroundVideo(playerId) {
        // Switch the background-chrome to a chrome-only player once played
        $('#' + playerId)
            .removeAttr('style')
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);
        videos[playerId].$parentSlideshowWrapper
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);
        videos[playerId].$parentSlide
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);
        videos[playerId].status = 'open';
    }
    function setBackgroundVideo(playerId) {
        // Switch back to background-chrome when closed
        var $player = $('#' + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);
        videos[playerId].$parentSlide
            .addClass(classes.slideBackgroundVideo);
        videos[playerId].status = 'background';
        sizeBackgroundVideo($player);
    }
    function initEvents() {
        $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
            var playerId = $(evt.currentTarget).data('controls');
            startVideoOnClick(playerId);
        });
        $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
            var playerId = $(evt.currentTarget).data('controls');
            closeVideo(playerId);
        });
        // Listen to resize to keep a background-size:cover-like layout
        $(window).on('resize.videoPlayer', $.debounce(250, function() {
            if (youtubeLoaded) {
                sizeBackgroundVideos();
            }
        }));
    }
    function removeEvents() {
        $(document).off('.videoPlayer');
        $(window).off('.videoPlayer');
    }
    return {
        init: init,
        loadVideos: loadVideos,
        loadVideo: loadVideo,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
    };
})();
velatheme.slideshows = {};
velatheme.SlideshowSection = (function() {
    function SlideshowSection(container) {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#velaSlideshows' + sectionId;
        $('.velassVideo', slideshow).each(function() {
            var $el = $(this);
            velatheme.SlideshowVideo.init($el);
            velatheme.SlideshowVideo.loadVideo($el.attr('id'));
        });
        velatheme.slideshows[slideshow] = new velatheme.Slideshow(slideshow);
    }
    return SlideshowSection;
})();
velatheme.SlideshowSection.prototype = _.assignIn({}, velatheme.SlideshowSection.prototype, {
    onUnload: function() {
        delete velatheme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
        // Ignore the cloned version
        var $slide = $('.velassSlide' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },
    onBlockDeselect: function() {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});

velatheme.Variants = (function() {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
            var $element = $(element);
            var type = $element.attr('type');
            var currentOption = {};

            if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
                currentOption.value = $element.val();
                currentOption.index = $element.data('index');

                return currentOption;
            } else {
                return false;
            }
            } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
            }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);

        return currentOptions;
        },

        _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.product.variants;
        var found = false;

        variants.forEach(function(variant) {
            var match = true;
            var options = variant.options;

            selectedValues.forEach(function(option) {
            // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

            if (match) {
                match = (variant[option.index] === option.value);
            }
            });

            if (match) {
            found = variant;
            }
        });

        return found || null;
        },

        _onSelectChange: function() {

        var variant = this._getVariantFromOptions();

        this.$container.trigger({
            type: 'variantChange',
            variant: variant
        });

        if (!variant) {
            return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
            this._updateHistoryState(variant);
        }
        },

        _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
            return;
        }

        this.$container.trigger({
            type: 'variantImageChange',
            variant: variant
        });
        },

        _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
            return;
        }

        this.$container.trigger({
            type: 'variantPriceChange',
            variant: variant
        });
        },

        _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
            return;
        }

        this.$container.trigger({
            type: 'variantSKUChange',
            variant: variant
        });
        },

        _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
            return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
        },

        _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
        },

        // _.compact from lodash
        // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
        _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
            result[resIndex++] = value;
            }
        }
        return result;
        }
    });

    return Variants;
})();

velatheme.Product = (function() {
    var classes = {
        loading: 'loading',
        loaded: 'loaded',
        interactable: 'video-interactable',
        currentSlide: 'slick-current',
        productVideo: 'product__video',
        zoomInit: 'photo-zoom-init'
    };

    function Product(container) {
        var $container = this.$container = $(container);
        var sectionId = this.sectionId = $container.attr('data-section-id');
        this.inModal = $container.closest('.modal').length;
        this.$modal;

        this.settings = {
            enableHistoryState: $container.data('enable-history-state') || false,
            namespace: '.product-' + sectionId,
            zoom: $container.data('image-zoom') || false,
            inventory: $container.data('inventory') || false,
            modalInit: false,
            lazyLoadModalContent: $container.data('lazyload-content') || false,
            modalContentLoaded: false,
            slickInitialized: false,
            hasColorSwatches: false,
            hasImages: true,
            hasMultipleImages: false,
            imageSize: '620x'
        };

        this.classes = {
            onSale: 'on-sale',
            disabled: 'disabled',
            isModal: 'is-modal'
        };

        this.selectors = {
            productJson: 'ProductJson-' + sectionId,
            photoThumbs: '.product__thumb-' + sectionId,
            thumbSlider: '#ProductThumbs-' + sectionId,
            mainSlider: '#ProductPhotos-' + sectionId,
            productVideo: '.product__video',

            addToCart: '#AddToCart-' + sectionId,
            addToCartText: '#AddToCartText-' + sectionId,

            originalSelectorId: '#ProductSelect-' + sectionId,
            singleOptionSelector: '.variant__input-' + sectionId
        };

        if (!$('#' + this.selectors.productJson).html()) {
            return;
        }

        this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);
        this.$mainSlider = $(this.selectors.mainSlider);
        this.$thumbSlider = $(this.selectors.thumbSlider);
        this.$firstProductImage = this.$mainSlider.find('img').first();
        if (!this.$firstProductImage.length) {
            this.settings.hasImages = false;
        }

        this.init();
    }

    Product.prototype = $.extend({}, Product.prototype, {
        init: function() {
            this.initVariants();
            this.initImageSwitch();
            if (!this.inModal) {
                this.createImageCarousels();
            }
        },

        initVariants: function() {
            var options = {
                $container: this.$container,
                enableHistoryState: this.settings.enableHistoryState,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productObject
            };

            this.variants = new velatheme.Variants(options);
            // this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));

            var context = this,
                slidersReady = undefined;

            $(document).on('init', context.selectors.mainSlider, function(e) {
                setTimeout(function() {
                e.variant = window.defaultVariant
                if(slidersReady) {
                    context.updateVariantImage(e);
                };
                slidersReady = true;
                }, 20);
            });

            $(document).on('init', context.selectors.thumbSlider, function(e) {
                setTimeout(function() {
                e.variant = window.defaultVariant
                if(slidersReady) {
                    context.updateVariantImage(e);
                };
                slidersReady = true;
                }, 20);
            });
        },

        updateVariantImage: function(evt) {

            var variant = evt.variant;
            //this.$mainSlider.slick('slickUnfilter');
            //this.$mainSlider.slick('slickFilter', function(i, e) {
            //    return $(this).hasClass('v' + Shopify.handleize(variant.option1));
            //});

            // Manually reset indexes
            this.$mainSlider.find('.slick-slide').each(function(i, el) {
                $(el).attr('data-slick-index', i).attr('data-index', i);
            });

            //this.$thumbSlider.slick('slickUnfilter');
            //this.$thumbSlider.slick('slickFilter', function() {
            //    return $(this).hasClass('v' + Shopify.handleize(variant.option1));
            //});

            // Manually reset indexes
            this.$thumbSlider.find('.slick-slide').each(function(i, el) {
                $(el).attr('data-slick-index', i).attr('data-index', i);
            });

            this.$mainSlider.slick('slickGoTo', 0);
            this.$thumbSlider.slick('slickGoTo', 0);

            var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
            var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

            // If there is no index, slider is not initalized
            if (typeof imageIndex === 'undefined') {
                return;
            }

        },

        // Image/thumbnail toggling
        initImageSwitch: function() {
            if (!$(this.selectors.photoThumbs).length) {
                return;
            }

            var self = this;

            $(this.selectors.photoThumbs).on('click', function(evt) {
                evt.preventDefault();
            });
        },

        // Init zoom for each image in the main carousel
        initZoom: function($image) {
            var largeImage = $image.parent().data('zoom-size');
            $image.parent()
            .on('click', function(evt) {
                evt.preventDefault();
            })
            .zoom({
                on: 'click',
                url: largeImage,
                duration: 180,
                touch: false,
                onZoomIn: function() {
                $(this).addClass('photo-zoom-linked');
                },
                onZoomOut: function() {
                $(this).removeClass('photo-zoom-linked');
                }
            });
        },

        createImageCarousels: function() {
            if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
                return;
            }

            this.settings.hasMultipleImages = true;

            // Set starting slide (for both sliders)
            var $activeSlide = this.$mainSlider.find('.starting-slide');
            var startIndex = this._slideIndex($activeSlide);

            // Set pagination
            var slideQuantity = this.$thumbSlider.find('.product__thumb-item').length;
            var paginateBy = thumbnailsVertical ? 3 : 4;

            if(slideQuantity == paginateBy) {
                this.$thumbSlider.addClass('disable-tracking');
            }

            // Lame way to prevent duplicate event listeners
            this.$mainSlider.off('init');
            this.$mainSlider.off('beforeChange');
            this.$mainSlider.on('init', this.mainSlideInit.bind(this));
            this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

            this.$mainSlider.slick({
                asNavFor: this.selectors.thumbSlider,
                arrows: false,
                dots: false,
                infinite: false,
                initialSlide: startIndex
            });

            var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

            this.$thumbSlider.slick({
                asNavFor: this.selectors.mainSlider,
                slidesToShow: paginateBy,
                arrows: false,
                dots: false,
                infinite: false,
                vertical: thumbnailsVertical,
                verticalSwiping: thumbnailsVertical,
                focusOnSelect: true,
                customHeightMatching: thumbnailsVertical,
                initialSlide: startIndex
            });

            this.settings.slickInitialized = true;
        },

        destroyImageCarousels: function() {
            if (!this.settings.slickInitialized) {
                return;
            }

            if (this.$mainSlider) {
                this.$mainSlider.slick('unslick');
            }

            if (this.$thumbSlider) {
                this.$thumbSlider.slick('unslick');
            }

            this.settings.slickInitialized = false;
        },

        mainSlideInit: function(event, slick) {
            var $slider = slick.$slider;
            var $currentSlide = $slider.find('.' + classes.currentSlide);
            var $video = $currentSlide.find('.' + classes.productVideo);

            if (!$video.length) {
                return;
            }
        },

        beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
            var $slider = slick.$slider;
            var $currentSlide = $slider.find('.' + classes.currentSlide);
            var $prevVideo = $currentSlide.find('.product__video');
            var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        },

        resizeSlides: function() {
            if (!this.settings.hasMultipleImages) {
                return;
            }

            $(window).trigger('resize');
            setTimeout(function() {
                this.$mainSlider.slick('setPosition');
                this.$thumbSlider.slick('setPosition');
            }.bind(this), 500); // same timing as modal open transition
        },

        _slideIndex: function($el) {
            return $el.data('index');
        },

        onUnload: function() {
            this.$container.off(this.settings.namespace);
            $('body').off(this.settings.namespace);
            this.destroyImageCarousels();
        }
    });
    return Product;
})();   

Shopify.handleize = function (str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/g, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/g, "");
    }

    return str
};

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".velaSwatchProduct").forEach(function(swatchList) {
        let swatches = swatchList.querySelectorAll("li");

        if (swatches.length > 0) {
        // Select first swatch by default
        swatches[0].classList.add("active");
        }

        swatches.forEach(function(item) {
        item.addEventListener("click", function() {
            // remove active from all
            swatches.forEach(function(el) {
            el.classList.remove("active");
            });
            // add active to clicked
            item.classList.add("active");
        });
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll(".faq-accordion button");

    function toggleAccordion() {
        const itemToggle = this.getAttribute('aria-expanded');

        for (let i = 0; i < items.length; i++) {
            items[i].setAttribute('aria-expanded', 'false');
        }

        if (itemToggle === 'false') {
            this.setAttribute('aria-expanded', 'true');
        }
    }

    items.forEach(item => item.addEventListener('click', toggleAccordion));
});